export default "__VITE_ASSET__C3v8nLJE__"